import AHttpService from '@d-services/a-http-service/a-http-service';
import URLS from '@d-shared/urls/urls';

class VerdictsService extends AHttpService {
  async getVerdictOptions() {
    const response = await this._http.get(URLS.api.verdicts);
    return response.data.verdicts;
  }
}

export default new VerdictsService();
